import { render, staticRenderFns } from "./ticketLevelNumStatistics.vue?vue&type=template&id=0d4c485e&scoped=true&"
import script from "./ticketLevelNumStatistics.vue?vue&type=script&lang=js&"
export * from "./ticketLevelNumStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c485e",
  null
  
)

export default component.exports